// extracted by mini-css-extract-plugin
export var addToCartButton = "_jv-b";
export var arrowButtonContainer = "_jv-9";
export var arrowButtonIcon = "_jv-a";
export var carouselArrowButton = "_jv-6";
export var carouselElementContainer = "_jv-1";
export var left = "_jv-7";
export var productDisplayCarouselContainer = "_jv-0";
export var productTileContainer = "_jv-2";
export var productTileImage = "_jv-4";
export var productTileImageContainer = "_jv-3";
export var productTileTitle = "_jv-5";
export var right = "_jv-8";
export var sliderOverflow = "_jv-c";